import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20shapes%20in%20cream%20and%20peach%20tones%2C%20minimalist%20geometric%20elements%2C%20clean%20modern%20design%2C%20soft%20diffused%20lighting%2C%20elegant%20and%20welcoming%20atmosphere%2C%20no%20text%20or%20typography%2C%20abstract%20composition&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="免费91网页背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold font-heading text-background-50 leading-tight mb-6">
            免费91网页
            <span className="block text-primary-300 mt-2 text-xl md:text-3xl font-medium">
              官方入口与完整使用指南
            </span>
          </h1>
          <p className="text-base md:text-lg text-foreground-100/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            为您整理免费91网页的访问方式、功能介绍、使用技巧及常见问题解答，
            帮助您快速、安全地找到并使用免费91网页的全部核心功能，无需注册即可体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/access-methods"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all duration-200 text-base whitespace-nowrap cursor-pointer"
            >
              <i className="ri-links-line mr-2"></i>
              查看官方入口
            </Link>
            <Link
              to="/category/tutorials"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-semibold rounded-lg border border-background-50/30 transition-all duration-200 text-base whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line mr-2"></i>
              使用教程
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}